const selectors = {
  mobileDropdownTriggers: '.quick-ref__block__balance a'
};

export default function init ({ el, context }) {

  const nodeSelectors = {
    mobileDropdownTriggers: document.querySelectorAll(selectors.mobileDropdownTriggers)
  };

  for (var i = nodeSelectors.mobileDropdownTriggers.length - 1; i >= 0; i--) {
    nodeSelectors.mobileDropdownTriggers[i].addEventListener('click', async (e) => {
      e.preventDefault();
      var thisButton = e.currentTarget
      var thisUl = e.currentTarget.nextElementSibling
      if(thisUl.ariaHidden === 'true'){
        thisUl.ariaHidden = false
      } else {
        thisUl.ariaHidden = true
      }
    })
  }
}